module.exports = __webpack_public_path__ + "static/media/delegations.bc0cf376.jpg";